import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

const LoadingSpinner: React.FC<any> = ({ loading, children }: any) => {
  return typeof loading !== 'undefined' && !loading ? children : (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <CircularProgress />
    </div>
  );
};

export default LoadingSpinner;
